











export default {
    "name": "DropDown",
    "props": {
        'items': false,
        'currentValue': Object,
        'defaultLabel': String,
        'shownKey': String,
        'customClasses': String
    },
    "computed": {
        "itemKey": ()-> 
            if not this.shownKey then return "name" else return this.shownKey
    },
    "methods": {
        "click": ()-> 
            this.active = not this.active
            
        "closeListener": (e)-> 
            vm = @
            if not vm.$el.contains(e.target)
                vm.active = false
            return
    },
    "data": ()-> 
        return {
            itemsList: [],
            active: false,
            selectedItem: this.currentValue || {}
        }
    "mounted": ()->
        vm = @
        vm.itemsList = await vm.items
        document.addEventListener('click', vm.closeListener, true)
    "beforeDestroy": ()->
        vm = @
        document.removeEventListener('click', vm.closeListener, true)
    "watch": {
        "currentValue": (newVal, oldVal)-> 
            this.selectedItem = newVal
        "selectedItem": (newVal, oldVal) -> 
            console.log('Option sélectionnée :', newVal)
            this.$emit('dropdownClick', newVal)
    }
}
